import React from "react";
import styled from "styled-components";
import Col from "../components/Col";
import SubHeadline from "../components/SubHeadline";
import Strong from "../components/Strong";
import colors from "../config/colors";

import gmail from "../images/socialmedia/gmail.svg";
import github from "../images/socialmedia/github.svg";
import linkedin from "../images/socialmedia/linkedin.svg";
import skype from "../images/socialmedia/skype.svg";
import twitter from "../images/socialmedia/twitter.svg";
import xing from "../images/socialmedia/xing.svg";

const ImgWrap = styled.span`
  display: inline-block;
  width: 2.2rem;
  height: 2.2rem;
  line-height: 2.2rem;
  border: 1px solid ${colors.text};
  border-radius: 2.2rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 200ms cubic-bezier(0.29, 0.81, 0.59, 1.2);
  margin-right: 0.6rem;
`;

const Img = styled.img`
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  transition: all 200ms cubic-bezier(0.29, 0.81, 0.59, 1.2) 100ms;
`;

const List = styled.div``;
const ListItem = styled.a`
  display: flex;
  font-size: 1.1rem;
  line-height: 2.2rem;
  margin-bottom: 0.3rem;
  cursor: pointer;
  text-decoration: none;
  color: ${colors.text};

  &:hover {
    text-decoration: underline;
    ${ImgWrap} {
      transform: scale(1.2);
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.3);
    }

    ${Img} {
      transform: scale(1.1);
    }
  }
`;

const L = styled.span`
  flex: 1 0 auto;
`;

const R = styled.span``;

export default () => (
  <Col>
    <SubHeadline>
      <Strong>ONLINE</Strong>
    </SubHeadline>
    <List>
      <ListItem href="mailto:hello@tomraithel.de">
        <ImgWrap>
          <Img src={gmail} alt="gmail" />
        </ImgWrap>
        <L>hello@tomraithel.de</L>
      </ListItem>
      <ListItem href="skype:tomraithel">
        <ImgWrap>
          <Img src={skype} alt="skype" />
        </ImgWrap>
        <L>tomraithel</L>
      </ListItem>
      <ListItem href="https://twitter.com/tomraithel">
        <ImgWrap>
          <Img src={twitter} alt="twitter" />
        </ImgWrap>
        <L>@tomraithel</L>
      </ListItem>
      <ListItem href="https://github.com/tomraithel/">
        <ImgWrap>
          <Img src={github} alt="github" />
        </ImgWrap>
        <L>github.com/tomraithel</L>
      </ListItem>
      <ListItem href="https://www.xing.to/tomraithel">
        <ImgWrap>
          <Img src={xing} alt="xing" />
        </ImgWrap>
        <L>xing.to/tomraithel</L>
      </ListItem>
      <ListItem href="https://www.linkedin.com/in/tomraithel/">
        <ImgWrap>
          <Img src={linkedin} alt="linkedin" />
        </ImgWrap>
        <L>linkedin.com/in/tomraithel</L>
      </ListItem>
    </List>
  </Col>
);



// WEBPACK FOOTER //
// ./src/components/ContactOnline.js